import { NormalizedError } from '../types';
import { getErrorMessage } from '../handlers/errorMessages';
import store, { USER_INFORMATION } from '../store';
import { OverlayManager } from './index';

/**
 *
 * @param {*} num
 * @param {*} places
 * @returns
 */
const zeroPad = (num: number, places?: number) => String(num).padStart(places ?? 2, '0');

/**
 * Generates an overlay for errors.
 * @param {NormalizedError} props Properties for overlay.
 * @returns {string} Markup.
 */
export const error = (props: NormalizedError): HTMLDivElement => {
  const overlay = OverlayManager.createOverlayElement(
    'overlay',
    'bg-midnight font-tv2 opacity-100 flex justify-center items-center text-white flex-col absolute bottom-0 left-0 right-0 top-0 transition-opacity duration-200 enabled'
  );

  const { header, message, theme } = getErrorMessage(props);
  const date = new Date();
  const npawID = store.get(USER_INFORMATION)?.npawId ?? 'anonymous';

  const uniqueIdent = `${zeroPad(date.getDate())}-${zeroPad(
    date.getMonth() + 1
  )}-${date.getFullYear()}-${zeroPad(date.getHours())}:${zeroPad(date.getMinutes())}`;

  overlay.innerHTML = `
    <div class="z-[101] absolute bg-no-repeat bg-contain bg-top top-0 left-0 h-[calc((64_/_1920)_*_100vw)] w-[calc((129_/_1920)_*_100vw)] m-[calc((80_/_1920)_*_100vw)] bg-tv2-logo"></div>
    <div class="w-[41.5vw] ${theme === 'light' ? 'bg-white text-midnight' : ''}">
      <h1 class="font-bold text-[1.875vw] leading-[120%] mb-[1.25vw] m-[2.5vw]">${header}</h1>
      <div class="text-[1.46vw] leading-[140%] m-[2.5vw] mt-0">${message}</div>
    </div>
    <div class="absolute bottom-[0.5vw] left-[0.5vw] font-mono text-[0.6vw]">${npawID}: ${uniqueIdent}</div>
  `;

  return overlay;
};
